<template>
  <div :class="classObject">
    <div v-for="(item, index) in listData" :key="`${item.name}-${index}`">
      <PublicEcharts
        :id="`${assetId}-${index}-${item.name}`"
        :chartsData="item"
        :options="dealLiquidfillData(item)"
        usePropsOptions
      />
    </div>
  </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts";
const classNames = require("classnames");
export default {
  name: "Liquidfill",
  props: {
    listData: {
      type: Array,
      default: () => [],
    },
    assetId: {
      type: String,
      default: "twoYAxisBar",
    },
    className: {
      type: String,
      default: "",
    },
  },
  components: { PublicEcharts },
  data() {
    return {};
  },
  computed: {
    classObject: function () {
      return classNames({
        Liquidfill: true,
        [this.className]: !!this.className,
      });
    },
  },
  methods: {
    dealLiquidfillData(data) {
      const { name, value, unit } = data;
      const newValue = value / 100 > 1 ? 1 : value / 100;
      let option = {
        title: [
          {
            bottom: "15%",
            left: "center",
            text: name,
            textStyle: {
              color: "#28CCCB",
              fontSize: 16,
              fontWeight: 300,
            },
          },
        ],
        series: [
          {
            type: "liquidFill",
            radius: "45%",
            //水波
            color: ["rgba(40, 204, 203, .6)", "rgba(170, 238, 238, .6)"],
            data: [newValue, newValue, newValue],
            center: ["50%", "50%"],
            label: {
              normal: {
                formatter: `${value}${unit}`,
                fontSize: 20,
                fontWeight: 400,
                color: "#28CCCB",
              },
            },
            itemStyle: {
              //opacity: 0.7, // 波浪的透明度
              shadowBlur: 0, // 波浪的阴影范围
            },
            emphasis: {
              itemStyle: {
                opacity: 0.8, // 鼠标经过波浪颜色的透明度
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: 2,
                borderColor: "#28CCCB",
                shadowBlur: 20,
                shadowColor: "#28CCCB",
              },
            },
            backgroundStyle: {
              color: "#fff",
            },
          },
        ],
      };
      return option;
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.Liquidfill {
  width: 100%;
  height: 100%;
  @include setFlexBetween;

  & > div {
    width: 50%;
    height: 100%;
  }
}
</style>
